export default __webpack_public_path__ + "static/media/phone_ringing.36c6e1f2.mp3";